module.exports = __webpack_public_path__ + "static/NeueMontreal-LightItalic-824eb3c035687f33bd0f7661ebac9140.woff";